export interface IGetAccumulatedDevicesPositionsQueryDto {
    from: string;
    to: string;
    deviceIds: string;
    simplify?: boolean;
}
